import React from 'react';
import '../styles/ComingSoon.css';

function ComingSoon() {
  return (
    <div className="coming-soon-container">
      <div className="coming-soon-content">
        <h1>Coming Soon</h1>
        <div className="divider"></div>
        <p>We're working on the presentation page! This content will be available soon.</p>
        <div className="countdown">
          <div className="countdown-item">
            <span className="countdown-value">Stay</span>
            <span className="countdown-label">Tuned</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ComingSoon;
